import './App.css';
import QuizApp from './QuizApp';

function App() {
  return <QuizApp />;
}

export default App;
